<template>
    <div>
        <transition name="fade-5">
            <div v-if="show">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "show-alerts",
        data() {
            return {
                show: false
            }
        },
        mounted() {
            setTimeout(function (scope) {
                scope.show = true;
            }, 100, this);
            setTimeout(function (scope) {
                scope.show = false;
            }, 3500, this);
        }
    }
</script>
